import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
    ASSET_LOOKUP_CLEAR: "ASSET_LOOKUP_CLEAR",

    ASSET_LOOKUP_POST_FAILURE: "ASSET_LOOKUP_POST_FAILURE",
    ASSET_LOOKUP_POST_REQUEST: "ASSET_LOOKUP_POST_REQUEST",
    ASSET_LOOKUP_POST_SUCCESS: "ASSET_LOOKUP_POST_SUCCESS"
};

export const actionCreators = {
    clear: () => ({
        type: actionTypes.ASSET_LOOKUP_CLEAR
    }),

    postRequest: (reg: strings) => ({
        payload: { reg },
        type: actionTypes.ASSET_LOOKUP_POST_REQUEST,
        [WAIT_FOR_ACTION]: actionTypes.ASSET_LOOKUP_POST_SUCCESS,
        [ERROR_ACTION]: actionTypes.ASSET_LOOKUP_POST_FAILURE
    }),
    postSuccess: (data: any) => ({
        type: actionTypes.ASSET_LOOKUP_POST_SUCCESS,
        payload: { data }
    }),
    postFailure: (error: Error) => ({
        type: actionTypes.ASSET_LOOKUP_POST_FAILURE,
        error
    })
};

export default {
    create: actionCreators,
    type: actionTypes
};
